export default "__VITE_ASSET__eee28d75__"